// This file is used to execute any code before app is loaded.
import React from 'react';

// We get a warning about useLayoutEffect not doing anything in the server environment, which is fine
// we only care about the difference in the client environment.
// This is a workaround to avoid the warning.
if (typeof document === 'undefined') {
  React.useLayoutEffect = React.useEffect;
}
